import React from 'react';
import { motion } from 'framer-motion';
import { OVERVIEW } from '../data/content';

export default function Overview() {
  return (
    <section id="overview" className="py-24 md:py-32">
      <div className="container-x">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <div className="section-label">{OVERVIEW.eyebrow}</div>
            <h2 className="font-display text-[42px] md:text-[56px] leading-[1.02] mt-5 text-[color:var(--ink)]">
              {OVERVIEW.title}
              <span className="grad-text-red">{OVERVIEW.titleAccent}</span>
            </h2>
            <p className="mt-6 text-[17px] text-[color:var(--muted)] leading-relaxed max-w-md">{OVERVIEW.intro}</p>
          </div>

          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-5">
            {OVERVIEW.cards.map((c, i) => (
              <motion.div
                key={c.n}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: '-80px' }}
                transition={{ duration: 0.6, delay: i * 0.08 }}
                className="card-lift bg-white border border-line rounded-2xl p-7"
              >
                <div className="font-display text-navy text-2xl">{c.n}</div>
                <div className="mt-3 font-display text-[22px] text-[color:var(--ink)]">{c.title}</div>
                <p className="mt-3 text-[15px] text-[color:var(--muted)] leading-relaxed">{c.body}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
